exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.upgrade-info-container[data-v-309bc430] {\n  border-radius: 5px;\n  background-color: #eeeeee70;\n}\n.cera-med[data-v-309bc430] {\n  font-family: 'Cera Round Pro Medium', sans-serif;\n}\n.grey-font[data-v-309bc430] {\n  color: var(--theme-gray-text);\n}\n.details-grey-font[data-v-309bc430] {\n  color: #575757;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-309bc430","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/add-plan/PlanUpgradeCard.vue
// module id = 1474
// module chunks = 0